export const enum TmFontFamilies {
  SYSTEM = 'system-ui',
  ARIAL = 'Arial,Helvetica,sans-serif',
  COMIC_SANS = 'Comic Sans MS,cursive',
  COURIER = 'Courier New,Courier,monospace',
  GEORGIA = 'Georgia,serif',
  LUCIDA = 'Lucida Sans Unicode,Lucida Grande,sans-serif',
  TAHOMA = 'Tahoma,Geneva,sans-serif',
  TIMES_NEW_ROMAN = 'Times New Roman,Times,serif',
  TREBUCHET = 'Trebuchet MS,Helvetica,sans-serif',
  VERDANA = 'Verdana,Geneva,sans-serif',
}
